/*
 * @Author: your name
 * @Date: 2021-11-27 16:57:06
 * @LastEditTime: 2021-12-18 13:48:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /eventsEditor/projects/events-editor/src/lib/events-editor.module.ts
 */
import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsEditorComponent } from './events-editor.component';
import { InternalsComponent } from './command-source/internals/internals.component';
import { ParameterEditorComponent } from './parameter-editor/parameter-editor.component';
import { ComboListModule } from '@farris/ui-combo-list';
import { FormsModule } from '@angular/forms';
import { CommandSourceComponent } from './command-source/command-source.component';
import { ModalModule } from '@farris/ui-modal';
import { FDropdownDirectiveTypeModule } from '@farris/ui-dropdown';
import { FarrisTooltipModule } from '@farris/ui-tooltip';
import { InputGroupModule } from '@farris/ui-input-group';
import { GSPMetadataServiceModule, MetadataSelectModule } from '@gsp-lcm/metadata-selector';
import { MetadataRTSelectModule, GSPMetadataRTServiceModule } from '@gsp-lcm/metadatart-selector';
import { ViewModelComponent } from './view-model/view-model.component';
import { FarrisIDEParameterEditorModule } from '@farris/ide-parameter-editor';
import { AppNavigationSelectorComponent, AppNavigationSelectorModule } from '@farris/app-navigation-selector';
import { LocaleModule } from '@farris/ui-locale';

@NgModule({
  declarations: [
    EventsEditorComponent,
    InternalsComponent,
    ParameterEditorComponent,
    CommandSourceComponent,
    ViewModelComponent,
  ],
  imports: [
    ComboListModule,
    FormsModule,
    CommonModule,
    ModalModule.forRoot(),
    FDropdownDirectiveTypeModule,
    FarrisTooltipModule,
    InputGroupModule,
    GSPMetadataServiceModule.forRoot(''),
    MetadataSelectModule,
    MetadataRTSelectModule,
    GSPMetadataRTServiceModule.forRoot(''),
    FarrisIDEParameterEditorModule,
    AppNavigationSelectorModule,
    LocaleModule.forRoot('')
  ],
  exports: [EventsEditorComponent],
  entryComponents: [
    ViewModelComponent,
    AppNavigationSelectorComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: localStorage.getItem('languageCode') || 'zh-CHS' }
  ]
})
export class EventsEditorModule { }
